import { appShadowRoot } from '../js/common/elements';

let retry = 0;
const valueMap = [
  'All',
  'Certification',
  'Community',
  'Perspectives',
  'Documentation',
  'Event',
  'Perspective',
  'Troubleshooting',
  'Tutorial',
];

function selectDropDown(value) {
  let newText = appShadowRoot.querySelector('.CoveoSearchBoxDropdown [data-value="0"]')?.textContent.trim() || '';

  (appShadowRoot.querySelectorAll('.CoveoSearchBoxDropdown .search-dropdown .is-selected') || []).forEach((item) =>
    item.classList.remove('is-selected'),
  );
  (appShadowRoot.querySelectorAll(`.CoveoSearchBoxDropdown .search-dropdown  [data-value="${value}"]`) || []).forEach(
    (item) => {
      newText = item.textContent.trim();
      item.classList.add('is-selected');
    },
  );
  (appShadowRoot.querySelectorAll('.CoveoSearchBoxDropdown .searchResult span') || []).forEach((item) => {
    item.textContent = newText;
  });
}

function wireSearchBar() {
  const searchMenus = appShadowRoot.querySelectorAll('.CoveoSearchBoxDropdown .search-dropdown') || [],
    searchBtns = appShadowRoot.querySelectorAll('.CoveoSearchBoxDropdown .searchResult') || [],
    searchBtnIcons = appShadowRoot.querySelectorAll('.CoveoSearchBoxDropdown .searchResult .spectrum-Icon') || [];

  searchBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      searchMenus.forEach((menu) => menu.classList.toggle('is-open'));
      searchBtnIcons.forEach((icon) => icon.classList.toggle('is-rotated'));
    });
  });

  searchMenus.forEach((menu) => {
    menu.addEventListener('click', (e) => {
      let selectedOption = e.target.closest('.coveo-dropdown-item');
      if (selectedOption) selectDropDown(selectedOption.dataset.value);
    });
    menu.addEventListener('mouseleave', () => {
      searchMenus.forEach((m) => m.classList.remove('is-open'));
      searchBtnIcons.forEach((icon) => icon.classList.remove('is-rotated'));
    });
  });
}

const setupCoveo = () => {
  // Get Coveo solution metadata
  function getCoveoSolMeta() {
    return appShadowRoot.querySelector('meta[name="coveo-solution"]')
      ? appShadowRoot.querySelector('meta[name="coveo-solution"]').content
      : '';
  }

  //UGP - 5712 for popular search results based on product
  function setContext(args) {
    args.payload.context = args.payload.context || {};
    args.payload.context.learning_product = getCoveoSolMeta();
    args.payload.mlParameters = {
      filters: {
        originLevel1: 'Experience League Learning Hub',
        originLevel2: 'default',
        c_context_learning_product: getCoveoSolMeta(),
      },
    };
  }

  let searchBoxRoot = appShadowRoot.getElementById('CoveoSearchBox');
  let searchPageRoot = Coveo.$$(document).find('#search');
  // 2. Configure a search endpoint

  //Please Remove Coveo search token initialization while deploying the code to the learning site.
  let coveoSearchToken = '';

  if (sessionStorage.getItem('coveoToken')) {
    coveoSearchToken = sessionStorage.getItem('coveoToken');
  }

  if (!searchPageRoot) {
    /* Include Search Page Path here */
    window.fullSearchPagePath = `/search.html?lang=${document.documentElement.lang || 'en'}`;
    if (location.pathname.startsWith('/docs')) {
      window.fullSearchPagePath = `${window.fullSearchPagePath}#f:el_product=[${(
        (appShadowRoot.querySelector('meta[name="solution"]') || {}).content || ''
      )
        .split(/\s*,\s*/)[0]
        .replace(/\s/g, '%20')}]`;
    }
    Coveo.SearchEndpoint.configureCloudV2Endpoint('', coveoSearchToken);
    // 3. Initialize a Searchbox component

    try {
      /**-- Laearning - Coveo Language mapping should be defined from the following links
           * Learning values taken from language dropdown on UI
           * Coveo Language Mapping Link = https://docs.coveo.com/en/421/javascript-search-framework/change-the-language-of-your-search-interface
          -- **/
      let learningCoveoLangMapping = {
        'zh-Hans': 'zh-cn',
        'zh-Hant': 'zh-tw',
        nl: 'nl',
        en: 'en',
        fr: 'fr',
        de: 'de',
        it: 'it',
        ja: 'ja',
        ko: 'ko',
        'pt-BR': 'pt-br',
        es: 'es-es',
        sv: 'sv',
      };

      // currentUserLang is fetching from session storage with key lang
      let userLang = document.documentElement.lang;
      try {
        userLang = learningCoveoLangMapping[userLang];
      } catch (error) {
        userLang = 'en';
      }
      const script = document.createElement('script');
      script.src = 'https://static.cloud.coveo.com/searchui/v2.10088/js/cultures/' + userLang + '.js';
      document.head.appendChild(script);
      script.onload = function () {
        Coveo.initSearchbox(searchBoxRoot, window.fullSearchPagePath);
      };
    } catch (error) {
      console.log(error);
    }
  }

  if (window.location.hash) {
    let allQueryParams = window.location.hash.split('&').map(function (r) {
      let [key, value] = r.split('=');

      return {
        key,
        value,
      };
    });
    console.log('allQueryParams check', allQueryParams);
    let qQueryParam = allQueryParams.find(function (r) {
      return r.key === '#q' || r.key === 'q';
    });
    if (qQueryParam && qQueryParam.value && qQueryParam.value.length > 0) {
      EnableSearch();
    }
  }

  //UGP - 5712 for popular search results based on product
  try {
    Coveo.$$(searchBoxRoot).on('doneBuildingQuery', function () {
      localStorage.setItem('c_context_learning_product', getCoveoSolMeta());
    });
  } catch (error) {
    console.log(error);
  }
  try {
    Coveo.$$(searchBoxRoot).on('buildingQuerySuggest', function (e, args) {
      setContext(args);
    });
  } catch (e) {
    console.log(e);
  }
  //End for UGP - 5712

  wireSearchBar();

  try {
    Coveo.$$(searchBoxRoot).on('newQuery', function () {
      let searchDropDownValue = 0;
      let root = appShadowRoot.querySelector('.CoveoSearchBox');

      try {
        searchDropDownValue = parseInt(
          appShadowRoot.querySelector('.search-dropdown .is-selected').getAttribute('data-value'),
        );
      } catch (err) {
        console.log(err);
      }

      if (root !== null && searchDropDownValue !== 0) {
        Coveo.state(root, 'f:@el_contenttype', [valueMap[searchDropDownValue]]);
      } else if (root !== null) {
        Coveo.state(root, 'f:@el_contenttype', ['']);
      }
    });
  } catch (error) {
    console.log(error);
  }
};

function init(callback) {
  let interval;
  const observer = window.observer;
  if (observer === undefined) {
    interval = setInterval(() => {
      if (retry > 5) {
        clearInterval(interval);
        observer.once('start', callback);
      } else if (observer !== undefined) {
        clearInterval(interval);
        observer.once('start', callback);
      } else {
        retry++;
      }
    }, 200);
  } else {
    observer.once('start', callback);
  }
}

init(setupCoveo);
